import { type ReactNode } from 'react'

import { Modal, TransparentIconButton } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import {
  GlobalCommandModalCloseAreaStyled,
  GlobalCommandModalContentAreaStyled,
  GlobalCommandModalLayoutStyled,
} from './styles/GlobalCommandModalLayoutStyled'

/**
 * Dismiss open popovers when the modal opens. Triggers ClickAwayListener
 * on Tooltip-based popovers. Fires during onEnter, after MUI captures the
 * previously focused element for restoration.
 */
const dismissPopovers = () => document.body.click()

interface IGlobalCommandModalProps {
  isOpen: boolean
  onClose: () => void
  onEntered?: () => void
  children: ReactNode
}

export const GlobalCommandModal = ({
  isOpen,
  onClose,
  onEntered,
  children,
}: IGlobalCommandModalProps) => {
  const intl = useProcurifyIntl()

  return (
    <Modal
      aria-label={intl.formatMessage(messages.modalAriaLabel)}
      maxWidth='sm'
      fullWidth
      open={isOpen}
      onClose={onClose}
      keepMounted
      TransitionProps={{
        onEnter: dismissPopovers,
        onEntered,
      }}
    >
      <Modal.Card cycleFocus>
        <GlobalCommandModalLayoutStyled>
          <GlobalCommandModalContentAreaStyled>
            {children}
          </GlobalCommandModalContentAreaStyled>

          <GlobalCommandModalCloseAreaStyled>
            <TransparentIconButton
              aria-label={intl.formatMessage(messages.closeButtonAriaLabel)}
              icon='times'
              analyticsId='global-search-close-button'
              onClick={onClose}
            />
          </GlobalCommandModalCloseAreaStyled>
        </GlobalCommandModalLayoutStyled>
      </Modal.Card>
    </Modal>
  )
}
